export const removeOpSuffix = (val: string): string => {
	if (val.endsWith('-upload')) {
		return val.slice(0, -7);
	} else if (val.endsWith('-view')) {
		return val.slice(0, -5);
	} else {
		return val;
	}
};

export const opWithView = (val: string): string => {
	if (val.endsWith('-upload')) {
		return `${val.slice(0, -7)}-view`;
	} else {
		return val;
	}
};

export const switchOpSuffix = (val: string): string => {
	if (val.endsWith('-upload')) {
		return `${val.slice(0, -7)}-view`;
	} else if (val.endsWith('-view')) {
		return `${val.slice(0, -5)}-upload`;
	} else {
		return val;
	}
};

export const isLegacyOp = (val: string): boolean => {
	if (!val.endsWith('-view') && !val.endsWith('-upload') && val !== 'Prometheus Administrators') {
		return true;
	} else {
		return false;
	}
};
